import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import {
  Box,
  Typography,
  Button,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@material-ui/core";
import ErrorIcon from "@material-ui/icons/Error";
import WarningIcon from "@material-ui/icons/Warning";
import InfoIcon from "@material-ui/icons/Info";

const InvalidPaymentLinkView = (props) => {
  const { t } = useTranslation();

  return (
    <Box className={props.classes.root}>
      <Box className={props.classes.container}>
        <ErrorIcon className={props.classes.icon} />
        <Typography variant="h4" className={props.classes.title}>
          {t("payment_invalid.title")}
        </Typography>
        <Typography variant="subtitle1" className={props.classes.subtitle}>
          {t("payment_invalid.subtitle")}
        </Typography>

        <Box className={props.classes.infoBox}>
          <Typography variant="body1" gutterBottom>
            {t("payment_invalid.explanation")}
          </Typography>
          <List className={props.classes.list}>
            <ListItem className={props.classes.listItem}>
              <ListItemIcon className={props.classes.listItemIcon}>
                <WarningIcon color="warning" />
              </ListItemIcon>
              <ListItemText
                primary={t("payment_invalid.reasons.1")}
                className={props.classes.listItemText}
              />
            </ListItem>
            <ListItem className={props.classes.listItem}>
              <ListItemIcon className={props.classes.listItemIcon}>
                <WarningIcon color="warning" />
              </ListItemIcon>
              <ListItemText
                primary={t("payment_invalid.reasons.2")}
                className={props.classes.listItemText}
              />
            </ListItem>
          </List>
        </Box>
      </Box>
    </Box>
  );
};

export default InvalidPaymentLinkView;
